<div class="overlay-content" *ngIf="control && player && !control.displayTourHint">
  <div class="overlay">
    <div class="content">
      <div class="tour tour-continue" *ngIf="!control.displayTourHint">
        <div class="title">{{'call.CAPTURING_RESPONSE' | transloco}}</div>
        <div class="message">{{'call.TOUR_MESSAGE' | transloco}}</div>
        <quant-button type="button"
          [label]="callStore.getHints() != '' ? ('call.NEXT' | transloco) : ('call.START_CALL' | transloco)"
          hierarchy="primary" size="xs" [disabled]="false" (click)="next()">
        </quant-button>
      </div>
    </div>
  </div>
</div>
